import React from 'react';
import { HyperdbListing } from '../../../hyperdb';

export default HyperdbListing({
  collectionName: 'users',
  namespace: 'user',
  mountedUrl: '/users',
  title: 'Users',
  columns: [
    { attribute: 'name', sortable: false },
    { attribute: 'email', sortable: false },
    { label: 'group', value: (o) => o.groups[0], sortable: false }
  ],
  useQuickSearch: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/users/containers/Listing.jsx